<div class="project-not-found">
  <h2>Project Not Found</h2>
  <div>
    <p>Sorry, we couldn't find the project you were looking for.</p>
    <p>
      If you believe this to be an error, please <a href="https://jira.linuxfoundation.org/plugins/servlet/theme/portal/4" target="_blank">contact support</a>.
    </p>
  </div>
</div>
